import _extends from '@babel/runtime/helpers/extends';
import React__default, { useRef } from 'react';
import PT from 'prop-types';
import styled from 'styled-components';
import { F as FileUploadContext } from '../FileUploadContext-CI9_em1Z.js';
import { F as FileUploadButton$1 } from './FileUploadButton-CJAHb0nN.js';
import { n as noop } from '../../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';

const Input = /*#__PURE__*/styled('input').withConfig({
  componentId: "sc-storm-ui-30063520__sc-1g0746y-0"
})(["display:none;"]);
const FileUploadButton = ({
  accept,
  children,
  description,
  disabled,
  errorText,
  fullWidth,
  inputId,
  label,
  multiple,
  name,
  onChange,
  onCloseAlert,
  primary,
  transparent,
  small,
  hideLabel,
  icon,
  buttonProps,
  ...rest
}) => {
  const inputRef = useRef(null);
  const handleOnChange = event => {
    const fileList = event.target.files;
    const fileNames = [...fileList].map(file => file);
    onChange === null || onChange === void 0 || onChange(event, fileNames);
  };
  return /*#__PURE__*/React__default.createElement(FileUploadContext.Provider, {
    value: {
      description,
      disabled,
      errorText,
      fullWidth,
      inputId,
      inputRef,
      onCloseAlert
    }
  }, /*#__PURE__*/React__default.createElement(Input, _extends({}, rest, accept && {
    accept: accept.toString()
  }, {
    "aria-hidden": "true",
    id: inputId,
    name: name,
    tabIndex: -1,
    type: "file",
    onChange: handleOnChange,
    ref: inputRef,
    multiple: multiple
  })), /*#__PURE__*/React__default.createElement(FileUploadButton$1, _extends({}, buttonProps, {
    label: label,
    type: "button",
    primary: primary,
    transparent: transparent,
    hideLabel: hideLabel,
    icon: icon,
    small: small
  })));
};
FileUploadButton.propTypes = {
  /**
   * Specifies allowed file types
   */
  accept: PT.arrayOf(PT.string.isRequired),
  /**
   * Rendered list of uploader descriptions
   */
  description: PT.node,
  /**
   * Specifies if the control is disabled
   */
  disabled: PT.bool,
  /**
   * Text displayed in Alert component when an error occurs
   */
  errorText: PT.string,
  /**
   * Specifies if the control takes full width of parent element
   */
  fullWidth: PT.bool,
  /**
   * ID for file input
   */
  inputId: PT.string.isRequired,
  /**
   * Text displayed as Button component label
   */
  label: PT.string.isRequired,
  /**
   * Specifies that the control will accept one or more values
   */
  multiple: PT.bool,
  /**
   * Name of the form control
   */
  name: PT.string,
  /**
   * Callback function called when file(s) are selected from file system
   */
  onChange: PT.func,
  /**
   * Callback function called when Alert close button is selected
   */
  onCloseAlert: PT.func,
  /**
   * Render small variant of Button
   */
  small: PT.bool,
  /**
   * Render primary variant of Button
   */
  primary: PT.bool,
  /**
   * Render transparent variant of Button
   */
  transparent: PT.bool
};
FileUploadButton.defaultProps = {
  accept: undefined,
  description: undefined,
  disabled: false,
  errorText: '',
  fullWidth: false,
  multiple: false,
  name: '',
  onChange: noop,
  onCloseAlert: noop,
  small: false,
  primary: false,
  transparent: false
};

export { FileUploadButton as F };
//# sourceMappingURL=index-Ca3EE33q.js.map
